import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLaptopCode, faCode, faDesktop} from '@fortawesome/free-solid-svg-icons'




export default [
  {
    id: 1,
    icon: <FontAwesomeIcon icon={faLaptopCode} className="service-icon"/>,
    title: "web development",
    text: `Build awesome web applications with latest technologies.`,
  },
  {
    id: 2,
    icon: <FontAwesomeIcon icon={faDesktop} className="service-icon"/>,
    title: "web design",
    text: `Design user friendly and responsive website that scale on both mobile and desktop.`,
  },
  {
    id: 3,
    icon: <FontAwesomeIcon icon={faCode} className="service-icon"/>,
    title: "Clean Code",
    text: `I'm an advocate for clean and reusable code.🤗`,
  },
]
